'use client';

import { createContext, useContext, ReactNode } from 'react';
import type { Translations, Locale } from '@/lib/i18n';
import { getTranslations } from '@/lib/i18n';

const TranslationContext = createContext<{ t: Translations; locale: Locale }>({
    t: getTranslations('en'),
    locale: 'en',
});

export function TranslationProvider({
    locale,
    children,
}: {
    locale: Locale;
    children: ReactNode;
}) {
    const t = getTranslations(locale);
    return (
        <TranslationContext.Provider value={{ t, locale }}>
            {children}
        </TranslationContext.Provider>
    );
}

export function useTranslations() {
    return useContext(TranslationContext);
}
